import { useState } from "react";

import clsx from "clsx";
import { useToasts } from "react-toast-notifications";
import { twMerge } from "tailwind-merge";

import { GenericTooltip } from "@components/tooltip-container";
import { ConfirmationSlideout } from "@components/v2/confirmation-slideout";
import { useIsAccountOwnerOrAdmin } from "@hooks/use-account-owner";

export function SyncViewReordering({
  updateSavedViewOrderingToAllAccountManagers,
  className,
  includeReorderingTitle = true,
}: {
  updateSavedViewOrderingToAllAccountManagers: () => Promise<void>;
  className?: string;
  includeReorderingTitle?: boolean;
}) {
  const [isConfirmingReordering, setIsConfirmingReordering] = useState(false);

  const isAdminOrAccountOwners = useIsAccountOwnerOrAdmin();
  const { addToast } = useToasts();

  return (
    <div
      className={twMerge(
        "flex flex-row items-center font-bold text-sm mt-2 w-full",
        className,
      )}
    >
      {!isConfirmingReordering && includeReorderingTitle && (
        <div className=" ">Reorder</div>
      )}
      {isAdminOrAccountOwners && !isConfirmingReordering && (
        <GenericTooltip
          content="Only Account Owners can take this action"
          className={clsx("flex flex-row items-center", {
            " ml-auto": includeReorderingTitle,
          })}
        >
          <div
            onClick={() => setIsConfirmingReordering(true)}
            className={clsx(
              "cursor-pointer  text-primary hover:text-cosmic+2 hover:underline hover:underline-offset-4 ",
              { " ml-auto": includeReorderingTitle },
            )}
          >
            Sync ordering to all users
          </div>
        </GenericTooltip>
      )}
      {isAdminOrAccountOwners && (
        <ConfirmationSlideout
          className=" ml-auto"
          isOpen={isConfirmingReordering}
          title="Reorder Saved Views?"
          onConfirm={async () => {
            await updateSavedViewOrderingToAllAccountManagers();

            addToast("Saved views ordering has been synced to all users", {
              appearance: "success",
            });
            setIsConfirmingReordering(false);
          }}
          onClose={() => setIsConfirmingReordering(false)}
        />
      )}
    </div>
  );
}
